"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("../form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderLicenseSuccessPanel = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(OrderLicenseSuccessPanel, _Component);

  function OrderLicenseSuccessPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OrderLicenseSuccessPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderLicenseSuccessPanel.__proto__ || (0, _getPrototypeOf2.default)(OrderLicenseSuccessPanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleLinkClick = function () {
      _this.props.pushRoute("/ilmoitukset");
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OrderLicenseSuccessPanel, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tilaa maksullinen profiili" }),
        this.renderCompanySuccessText(),
        this.renderUserSuccessText(),
        this.renderUserData(),
        this.renderInvoiceData(),
        this.renderRest()
      );
    }
  }, {
    key: "renderUserSuccessText",
    value: function renderUserSuccessText() {
      if (this.props.company) {
        return;
      }
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 text-center" },
        _react2.default.createElement("i", { className: "icon-mp-ok license-order-success-icon" }),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-xs-offset-2" },
          _react2.default.createElement(
            "h1",
            { className: "h3" },
            "Lisenssin tilaaminen onnistui!"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Voit nyt n\xE4hd\xE4 tarjouspyynt\xF6jen ja maa-aineksien tarjoajien yhteystiedot 6 kuukauden ajan."
          )
        )
      );
    }
  }, {
    key: "renderCompanySuccessText",
    value: function renderCompanySuccessText() {
      if (!this.props.company) {
        return;
      }
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 " },
          _react2.default.createElement("i", { className: "icon-mp-ok license-order-success-icon" }),
          _react2.default.createElement(
            "div",
            { className: "col-xs-8 col-xs-offset-2" },
            _react2.default.createElement(
              "h1",
              { className: "h3 text-center" },
              "Ammattilaisprofiili on nyt k\xE4yt\xF6ss\xE4si. Tervetuloa!"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Voit nyt n\xE4hd\xE4 ilmoitusten kaikki tiedot sek\xE4 karttamerkit niiden oikeissa paikoissa. Voit my\xF6s k\xE4ytt\xE4\xE4 Maap\xF6rssin kuljetussovellusta ja luoda sill\xE4 kuljetuksista kuljetusraportteja yrityksesi k\xE4ytt\xF6\xF6n.",
              _react2.default.createElement("br", null),
              "Profiili on voimassa 6 kuukautta."
            )
          )
        )
      );
    }
  }, {
    key: "renderUserData",
    value: function renderUserData() {
      var _props = this.props,
          user = _props.user,
          values = _props.values;


      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 col-xs-offset-2" },
        _react2.default.createElement(
          "h1",
          { className: "h4" },
          "Yhteystiedot "
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "strong",
            null,
            " Nimi:"
          ),
          " ",
          user.first_name,
          " ",
          user.last_name,
          " ",
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "strong",
            null,
            " S\xE4hk\xF6posti:"
          ),
          " ",
          user.email,
          " ",
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "strong",
            null,
            " Puhelinnumero:"
          ),
          " ",
          user.phone,
          " ",
          _react2.default.createElement("br", null)
        )
      );
    }
  }, {
    key: "renderInvoiceData",
    value: function renderInvoiceData() {
      var _props2 = this.props,
          user = _props2.user,
          values = _props2.values;

      if (!user.company_id) {
        return;
      }

      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 col-xs-offset-2" },
        _react2.default.createElement("br", null),
        _react2.default.createElement(
          "h1",
          { className: "h4" },
          " Laskutustiedot "
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "strong",
            null,
            " Yritys:"
          ),
          values.company_name,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "strong",
            null,
            " Y-tunnus:"
          ),
          values.business_id,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "strong",
            null,
            " Osoite:"
          ),
          values.company_address,
          " ",
          values.company_postal_code,
          " ",
          values.company_postal_area,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "strong",
            null,
            " Tilausviite:"
          ),
          " ",
          values.order_reference,
          _react2.default.createElement("br", null)
        )
      );
    }
  }, {
    key: "renderRest",
    value: function renderRest() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 text-center" },
        _react2.default.createElement(
          "div",
          { className: "col-xs-12" },
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(_Button2.default, {
                text: "Selaa ilmoituksia",
                additionalClasses: "button-set-width",
                onClick: this.handleLinkClick
              })
            )
          )
        )
      );
    }
  }]);
  return OrderLicenseSuccessPanel;
}(_react.Component), _class.propTypes = {
  company: _react.PropTypes.object,
  values: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object.isRequired,
  pushRoute: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = OrderLicenseSuccessPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/license/OrderLicenseSuccessPanel.js
 ** module id = 1154
 ** module chunks = 0
 **/